module.exports = __webpack_public_path__ + "img/userid-tip.359c6e1.png";